import { combineReducers } from 'redux';
import {
  fetchInfoEvents,
  fetchInfoEventsCount,
  markAllAsRead,
  markAsRead,
  readyToFetchInfoEvents,
} from '../sagas/infoEvents/actions';
import { changeCurrentInfoEvent } from '../components/Messages/actions';
import { logoutButtonClick } from '../components/Auth/actions';
import { changeCurrentDevice } from '../components/Header/actions';

const infoEvents = (state = [], action) => {
  if (action.type === fetchInfoEvents.done.type) {
    if (action.payload.params.params.Take !== 3) {
      return action.payload.result.cursorInfo && action.payload.result.cursorInfo.currentOffset > 10
        ? [...state, ...action.payload.result.data]
        : action.payload.result.data;
    }
  }

  if (action.type === logoutButtonClick.type) {
    return [];
  }

  if (action.type === changeCurrentDevice.type) {
    return [];
  }

  if (action.type === markAsRead.done.type) {
    const eventId = JSON.parse(action.payload.params.body).eventIds[0];
    const event = state.filter(i => i.id === eventId).pop();

    event.isRead = true;
    return [...state, ...event];
  }

  if (action.type === markAllAsRead.done.type) {
    return state.map(x => ({ ...x, isRead: true }));
  }

  return state;
};

const notificationInfoEvents = (state = [], action) => {
  if (action.type === fetchInfoEvents.done.type) {
    const params = action.payload.params.params;
    if (params.Skip === 0 && ['Alarm', 'Technical', 'Information'].every(group => params.Groups.includes(group))) {
      return action.payload.result.data;
    }
  }

  return state;
};

const currentInfoEvent = (state = {}, action) => {
  if (action.type === changeCurrentInfoEvent.type) {
    return action.payload.infoEvent;
  }

  if (action.type === fetchInfoEvents.done.type) {
    if (action.payload.params.params.Take !== 3) {
      return action.payload.result.data.length ? action.payload.result.data[0] : state;
    }
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const hasMore = (state = false, action) => {
  if (action.type === fetchInfoEvents.done.type) {
    if (action.payload.params.params.Take !== 3 && action.payload.result.cursorInfo) {
      return action.payload.result.cursorInfo.itemsLeft > 0;
    }
  }

  if (action.type === logoutButtonClick.type) {
    return false;
  }

  return state;
};

const readyToFetch = (state = false, action) => {
  if (action.type === readyToFetchInfoEvents.type) {
    return true;
  }

  return state;
};

const unreadEventsCount = (state = 0, action) => {
  if (action.type === fetchInfoEventsCount.done.type) {
    let newState = 0;
    const unread = action.payload.result.unread;
    newState += unread.alarm;
    newState += unread.technical;
    newState += unread.information;
    return newState;
  }
  if (action.type === markAsRead.done.type) {
    return state - 1;
  }
  if (action.type === markAllAsRead.done.type) {
    return 0;
  }
  if (action.type === logoutButtonClick.type) {
    return false;
  }

  return state;
};

export default combineReducers({
  infoEvents,
  notificationInfoEvents,
  currentInfoEvent,
  hasMore,
  readyToFetch,
  unreadEventsCount,
});



// WEBPACK FOOTER //
// ./src/reducers/infoEvents.js